import { useAtom } from "jotai/index";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { headerTitle } from "@/store/store";
import StatisticsVisualizationModule
  from "@/module/service-configs-module/statistics-visualization-module/statistics-visualization-module";

const StatanalyticsPage = () => {
  const { t } = useTranslation();

  const [, setHeaderTitle] = useAtom(headerTitle);
  useEffect(() => {
    setHeaderTitle(t("statanalytics"));
  }, [setHeaderTitle, t]);

  return <StatisticsVisualizationModule />;
};

export default StatanalyticsPage;
